import React, { PropsWithChildren } from 'react';

import styled, { css } from 'styled-components';

import { HeaderType } from 'interfaces/content-stack/contentStack.types';

import { checkHeaderType } from 'utils/functions';

export const Header = styled.div<HeaderProps>(
  ({ $headerPrimaryColor, $headerSecondaryColor, $type, $uppercase, $noPadding }) => css`
    position: relative;

    font-family: ${(props) => props.theme.fonts.fontFamilySecondary};
    font-weight: 700;

    ${
      $noPadding &&
      css`
        padding: 0 !important;
      `
    }

    ${
      $uppercase &&
      css`
        text-transform: uppercase;
      `
    }

    ${
      $type === 'Page Title'
        ? css`
            font-size: 3rem;
            margin-bottom: 0;
          `
        : $type === 'Homepage Title'
          ? css`
              font-size: 3rem;
              margin-bottom: 0;

              span {
                @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
                  display: block;

                  &:not(.headline-text) {
                    display: none;
                  }
                }
              }
            `
          : $type === 'H2'
            ? css`
                font-size: 3rem;
                margin-top: 0;
                margin-bottom: 0;
                font-weight: 500;
                line-height: 1.6;

                @media screen and (max-width: ${(props) => props.theme.breakpoints.md}) {
                  font-size: 2rem;
                }
              `
            : $type === 'H3'
              ? css`
                  font-size: 2rem;
                  @media screen and (max-width: ${(props) => props.theme.breakpoints.md}) {
                    font-size: 1.5rem;
                  }
                `
              : $type === 'H4'
                ? css`
                    font-size: 1.5rem;

                    @media screen and (max-width: ${(props) => props.theme.breakpoints.md}) {
                      font-size: 1.25rem;
                    }
                  `
                : $type === 'H5'
                  ? css`
                      font-size: 1.25rem;

                      @media screen and (max-width: ${(props) => props.theme.breakpoints.md}) {
                        font-size: 1.15rem;
                      }
                    `
                  : $type === 'p' &&
                    css`
                      font-family: ${(props) => props.theme.fonts.default};
                      font-size: 1.125rem;
                      text-transform: none;
                    `
    })}

    ${
      $headerPrimaryColor &&
      css`
        color: ${$headerPrimaryColor};
      `
    }

    .header-primary-color {
      color: ${$headerPrimaryColor ? $headerPrimaryColor : 'black'}
    }

    .header-secondary-color {
      color: ${$headerSecondaryColor ? $headerSecondaryColor : 'black'}
    }
  `
);

interface HeaderProps {
  $headerPrimaryColor: string | undefined;
  $headerSecondaryColor: string | undefined;
  $type?: HeaderType;
  $uppercase?: boolean;
  $noPadding?: boolean;
}

interface StackHeaderProps {
  headerPrimaryColor?: string | undefined;
  headerSecondaryColor?: string | undefined;
  uppercase?: boolean;
  headerType?: HeaderType;
  defaultHeaderType?: HeaderType;
  noPadding?: boolean;
}

const StackHeader: React.FC<PropsWithChildren<StackHeaderProps>> = ({
  headerPrimaryColor = undefined,
  headerSecondaryColor = undefined,
  noPadding,
  uppercase = true,
  children,
  headerType,
  defaultHeaderType,
  ...props
}) => {
  if (!headerType) {
    headerType = defaultHeaderType ?? 'H2';
  }

  return (
    <Header
      as={checkHeaderType(headerType) as any}
      $headerPrimaryColor={headerPrimaryColor}
      $headerSecondaryColor={headerSecondaryColor}
      $type={headerType}
      $uppercase={!!uppercase}
      $noPadding={noPadding}
      dangerouslySetInnerHTML={{ __html: children }}
      {...props}
    />
  );
};

export default React.memo(StackHeader);
